import React from 'react';
import { Dialog } from '@shared/components';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import useStyle from './style';

const noop = () => {};

const ErrorInfoDialog = ({
  open = false,
  accountId = '',
  handleClose = noop,
}) => {
  const classes = useStyle();
  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      open={open}
      onClose={handleClose}
      classes={{
        paper: classes.infoDialog,
      }}
    >
      <Dialog.Title hasClose>
        <Typography variant='h6'>Error</Typography>
      </Dialog.Title>
      <Dialog.Content>
        <div className='d-flex f-align-center f-justify-center flex-column h-100'>
          <Typography variant='h6' className='text-bold'>
            No Extensions were found for Account ({accountId}).
          </Typography>
        </div>
      </Dialog.Content>
      <Dialog.Actions>
        <Button
          className='m-2'
          variant='contained'
          onClick={handleClose}
          color='primary'
        >
          Close
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default ErrorInfoDialog;
